import React from "react";
import "./styles.scss";
import { BannerTagline, FeatureGrid } from "molecules";
import { Paragraph } from "atoms";
import { TEXTS } from "../../constants";

export default props => (
  <div className="promotion">
    <div className="promotion-container">
      <div className="header">
        <BannerTagline text={TEXTS.PROMOTION_TITLE} right />
        <Paragraph text={TEXTS.PROMOTION_DESCRIPTION} right />
      </div>
    </div>
    <FeatureGrid cards={props.cards || []} />
  </div>
);
